import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import './index.scss'

interface HomeSceneWrapperProps {
    header: React.ReactNode
    wrapperClass?: string
}
const HomeSceneWrapper = ({ header, wrapperClass, children }: PropsWithChildren<HomeSceneWrapperProps>) => (
    <main className={clsx('home-scene', wrapperClass)}>
        <header>
            <div className="global-container">{header}</div>
        </header>
        <div className="global-container">{children}</div>
    </main>
)

export default HomeSceneWrapper
